<div class="card-edit">
  <form class="card-edit-form" [formGroup]="fieldForm" (ngSubmit)="onSubmit()">
    <div class="card-edit-header">
      <div class="card-edit-title">
        <button type="button" class="back-button" aria-label="Back" (click)="onCancel()">
          <span class="back-icon">←</span>
        </button>
        <h6 class="fw-bold m-0">New Field</h6>
      </div>
      <button type="submit" class="black-button" [disabled]="fieldForm.invalid">Save Field</button>
    </div>

    <div class="card-edit-section">
      <div class="section-label">Identification</div>

      <label class="field-label">Field Name (Key)</label>
      <input class="field-input" type="text" placeholder="e.g. INVOICE_NUMBER" formControlName="name" />

      <div class="field-row">
        <label class="field-label">Description</label>
        <span class="field-helper">Instructions for extraction</span>
      </div>
      <textarea class="field-textarea" placeholder="What should this field contain?" formControlName="description"></textarea>
    </div>

    <div class="card-edit-divider"></div>

    <div class="card-edit-section">
      <div class="section-label">Configuration</div>

      <div class="field-grid">
        <div>
          <label class="field-label">Data Type</label>
          <select class="field-select" formControlName="dataType">
            <option value="string">Text (String)</option>
            <option value="number">Number</option>
            <option value="boolean">True/False</option>
            <option value="date">Date</option>
            <option value="enum">Enum</option>
          </select>
        </div>
        <div>
          <label class="field-label">Presence</label>
          <select class="field-select" formControlName="presence">
            <option value="occasional">Occasional</option>
            <option value="common">Common</option>
            <option value="rare">Rare</option>
          </select>
        </div>
      </div>
    </div>

    <div class="card-edit-divider"></div>

    <div class="card-edit-section">
      <ng-container *ngIf="fieldForm.get('dataType')?.value === 'enum'; else exampleValue">
        <div class="allowed-values-card">
          <div class="allowed-values-label">Allowed values</div>
          <div class="allowed-values-input-row">
            <input
              class="allowed-values-input"
              type="text"
              placeholder="Add new option..."
              [(ngModel)]="allowedValueInput"
              [ngModelOptions]="{ standalone: true }"
              (keydown.enter)="$event.preventDefault(); addAllowedValue()" />
            <button type="button" class="allowed-values-add" (click)="addAllowedValue()">+ Add</button>
          </div>
          <div class="allowed-values-list" *ngIf="allowedValues.length">
            <div class="allowed-values-item" *ngFor="let value of allowedValues; let idx = index">
              <span class="allowed-values-item-text">{{ value }}</span>
              <button type="button" class="allowed-values-item-remove" (click)="removeAllowedValue(idx)">
                <img src="../../../assets/img/icons/delete.svg" alt="Remove" />
              </button>
            </div>
          </div>
          <div class="field-error"
            *ngIf="fieldForm.get('dataType')?.value === 'enum' && fieldForm.get('enumValues')?.invalid">
            Add at least one option.
          </div>
        </div>
      </ng-container>
      <ng-template #exampleValue>
        <label class="field-label">Example Value</label>
        <input class="field-input" type="text" placeholder="e.g. 2024-05-12" formControlName="example" />
        <div class="field-footnote">Optional. Helps the AI understand formatting.</div>
      </ng-template>
    </div>
  </form>
</div>
